/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./language-packs.vue?vue&type=template&id=6425f711&scoped=true&"
import script from "./language-packs.vue?vue&type=script&lang=js&"
export * from "./language-packs.vue?vue&type=script&lang=js&"
import style0 from "./language-packs.vue?vue&type=style&index=0&id=6425f711&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6425f711",
  null
  
)

export default component.exports